import { createContext } from 'react';

const sortingContext = createContext();

export default sortingContext;
